import { FC } from 'react'
import BoltIcon from '@mui/icons-material/Bolt'
import BarChartIcon from '@mui/icons-material/BarChart'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import SpeedIcon from '@mui/icons-material/Speed'
import TuneIcon from '@mui/icons-material/Tune'
import NotificationsIcon from '@mui/icons-material/Notifications'
import SettingsIcon from '@mui/icons-material/Settings'
import DescriptionIcon from '@mui/icons-material/Description'
import { xxllncColor } from '../../../layout/theme/color'

export const FLOW = {
  blue: xxllncColor.dark100,
  blueBg: xxllncColor.opDark10,
  blueBorder: xxllncColor.opDark20,
  blueLight: xxllncColor.opDark10,
  green: xxllncColor.green100,
  greenBg: xxllncColor.opGreen10,
  greenBorder: xxllncColor.opGreen20,
  greenLight: xxllncColor.opGreen10,
  orange: xxllncColor.orange100,
  orangeBg: xxllncColor.opOrange20,
  orangeBorder: xxllncColor.opOrange20,
  red: xxllncColor.red100,
  gray: 'rgba(0,0,0,0.45)',
  grayBg: 'rgba(0,0,0,0.03)',
  grayBorder: 'rgba(0,0,0,0.08)',
  grayLight: 'rgba(0,0,0,0.02)',
  connector: xxllncColor.opDark20,
  cardRadius: '14px',
  nodeWidth: 620,
}

// eslint-disable-next-line camelcase
const CATEGORY_ICONS: Record<string, FC<{ fontSize?: 'small' | 'medium'; sx?: object }>> = {
  // eslint-disable-next-line camelcase
  bar_chart: BarChartIcon,
  // eslint-disable-next-line camelcase
  error_outline: ErrorOutlineIcon,
  speed: SpeedIcon,
  tune: TuneIcon,
  notifications: NotificationsIcon,
  settings: SettingsIcon,
  description: DescriptionIcon,
}

export const getCategoryIcon = (icon: string, sx?: object): JSX.Element => {
  // eslint-disable-next-line security/detect-object-injection
  const Icon = CATEGORY_ICONS[icon]
  return Icon ? <Icon fontSize="small" sx={sx} /> : <BoltIcon fontSize="small" sx={sx} />
}
